import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-text-fields",
  templateUrl: "./med-icon-text-fields.component.html",
})
export class MedIconTextFieldsComponent extends SvgMixinComponent {}
